export default "__VITE_ASSET__giBT$6IA__"